module.exports = __webpack_public_path__ + "img/logoVNPay.c1adc4c1.svg";